import { Navigate, useLocation } from "react-router-dom";
import { getAccountSession, getUserAccount } from "../../utils/auth";

interface RequireNoAthProps {
  children: React.ReactNode;
}

/**
 * `RequireNoAuth` is a React component that prevents authenticated users from accessing certain routes (e.g., login or register pages).
 * If an authenticated user attempts to visit a page that is protected by this component, they will be redirected to a predefined
 * page (usually the user's dashboard or home page).
 *
 * @param {React.ReactNode} children - The child components to render if the user is not authenticated.
 * @returns {React.ReactNode} The child components if the user is unauthenticated; otherwise, a redirect to the user's dashboard.
 */

export default function RequireNoAuth({ children }: RequireNoAthProps) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasRedirect = searchParams.get("redirect");
  
  // Check authentication before component renders
  const user = getUserAccount();
  const session = getAccountSession();
  
  if (session && user && !hasRedirect) {
    // Redirect to practice dashboard immediately
    return <Navigate to="/practice" replace />;
  }

  return children;
}
